import { Reveal } from "@/components/Reveal";

import logoPerrhijos from "@/assets/perrhijos_logo.webp";
import logoIfw from "@/assets/ifw_logo.webp";
import logoLiber from "@/assets/liber_logo.webp";
import logoCarniceria from "@/assets/gourmet_market_logo.webp";

export const CasesSection = () => {
  const cases = [
    { logo: logoPerrhijos, name: "Perrhijos y más", metric: "+300%", label: "seguidores", detail: "Colecciones agotadas · +10 videos virales" },
    { logo: logoIfw, name: "The IFW", metric: "$10.99", label: "CPL (antes $46)", detail: "2,084 leads por trimestre" },
    { logo: logoLiber, name: "Liber Financultura", metric: "14X", label: "ROAS promedio", detail: "CAC reducido 52% · +100 ventas en 45 días" },
    { logo: logoCarniceria, name: "La Carnicería Gourmet", metric: "+1000", label: "seguidores en 90 días", detail: "+40k vistas por video · Aumento en ventas" },
  ];

  return (
    <section id="cases" className="py-16 sm:py-20 lg:py-24 px-4 sm:px-6 lg:px-8 bg-muted/50">
      <div className="max-w-6xl mx-auto">
        <Reveal className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-primary mb-4">
            Resultados que hablan por sí solos
          </h2>
          <p className="text-base sm:text-lg text-primary">
            Casos reales. Métricas reales. Clientes reales.
          </p>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-2 gap-4 sm:gap-5 lg:gap-6">
          {cases.map((c, i) => (
            <Reveal key={i} delay={Math.min(i + 1, 6)}>
              <div className="group p-5 sm:p-6 rounded-2xl bg-card border border-border hover:border-accent transition-colors hover-lift h-full">
                <div className="flex flex-col items-center gap-4 mb-5">
                  <div
                    className="w-full h-40 rounded-2xl bg-primary/70 border border-primary/60 flex items-center justify-center overflow-hidden px-6"
                    title={c.name}
                  >
                    <img
                      src={c.logo}
                      alt={`Logo ${c.name}`}
                      className="h-24 sm:h-28 w-auto max-w-full object-contain drop-shadow-sm"
                      loading="lazy"
                      width="28"
                      height="28"
                    />
                  </div>
                </div>
                <div className="mb-2">
                  <span className="block text-sm text-foreground/80 font-medium mb-1">{c.label}</span>
                  <span className="text-3xl sm:text-4xl font-bold text-accent">{c.metric}</span>
                </div>
                <p className="text-xs sm:text-sm text-foreground/80">{c.detail}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
